import { render, staticRenderFns } from "./PrivacyPolicyPage.vue?vue&type=template&id=30a678ac&scoped=true"
import script from "./PrivacyPolicyPage.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyPage.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=30a678ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a678ac",
  null
  
)

export default component.exports